var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlankPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 110,
    viewBox: "0 0 210 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181 0H29C26.8 0 25 1.8 25 4V37H0V69H25V106C25 108.2 26.8 110 29 110H181C183.2 110 185 108.2 185 106V4C185 1.8 183.2 0 181 0ZM1 38H149V68H1V38ZM184 106C184 107.7 182.7 109 181 109H29C27.3 109 26 107.7 26 106V69H150V37H26V17H184V106ZM184 16H26V4C26 2.3 27.3 1 29 1H181C182.7 1 184 2.3 184 4V16Z",
    fill: "#A0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 5C33.6 5 32 6.6 32 8.5C32 10.4 33.6 12 35.5 12C37.4 12 39 10.4 39 8.5C39 6.6 37.4 5 35.5 5ZM35.5 11C34.1 11 33 9.9 33 8.5C33 7.1 34.1 6 35.5 6C36.9 6 38 7.1 38 8.5C38 9.9 36.9 11 35.5 11Z",
    fill: "#A0A0A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 5C44.6 5 43 6.6 43 8.5C43 10.4 44.6 12 46.5 12C48.4 12 50 10.4 50 8.5C50 6.6 48.4 5 46.5 5ZM46.5 11C45.1 11 44 9.9 44 8.5C44 7.1 45.1 6 46.5 6C47.9 6 49 7.1 49 8.5C49 9.9 47.9 11 46.5 11Z",
    fill: "#A0A0A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 5C55.6 5 54 6.6 54 8.5C54 10.4 55.6 12 57.5 12C59.4 12 61 10.4 61 8.5C61 6.6 59.4 5 57.5 5ZM57.5 11C56.1 11 55 9.9 55 8.5C55 7.1 56.1 6 57.5 6C58.9 6 60 7.1 60 8.5C60 9.9 58.9 11 57.5 11Z",
    fill: "#A0A0A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180 21H30V33H180V21ZM179 32H31V22H179V32Z",
    fill: "#A0A0A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29H54C55.1 29 56 28.1 56 27C56 25.9 55.1 25 54 25H36C34.9 25 34 25.9 34 27C34 28.1 34.9 29 36 29Z",
    fill: "#A0A0A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175 26H165V28H175V26Z",
    fill: "#A0A0A0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161 26H151V28H161V26Z",
    fill: "#A0A0A0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147 26H137V28H147V26Z",
    fill: "#A0A0A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108 42H78V44H108V42Z",
    fill: "#A0A0A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135 47H78V48H135V47Z",
    fill: "#A0A0A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126 51H78V52H126V51Z",
    fill: "#A0A0A0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130 55H78V56H130V55Z",
    fill: "#A0A0A0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59H78V60H112V59Z",
    fill: "#A0A0A0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122 63H78V64H122V63Z",
    fill: "#A0A0A0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64V42H5V64H72ZM42.9 63L53 55.3L63.1 63H42.9ZM6 63V43H71V63H64.7L53 54L42.2 62.3L27.5 49L12.1 63H6ZM27.5 50.4L41.4 63H13.6L27.5 50.4Z",
    fill: "#A0A0A0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52C54.7 52 56 50.7 56 49C56 47.3 54.7 46 53 46C51.3 46 50 47.3 50 49C50 50.7 51.3 52 53 52ZM53 47C54.1 47 55 47.9 55 49C55 50.1 54.1 51 53 51C51.9 51 51 50.1 51 49C51 47.9 51.9 47 53 47Z",
    fill: "#A0A0A0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30 105H180V73H30V105ZM31 74H179V104H31V74Z",
    fill: "#A0A0A0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M120 78H90V80H120V78Z",
    fill: "#A0A0A0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M102 92H72V98H102V92Z",
    fill: "#A0A0A0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138 92H108V98H138V92Z",
    fill: "#A0A0A0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M133 83H77V84H133V83Z",
    fill: "#A0A0A0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M124 87H86V88H124V87Z",
    fill: "#A0A0A0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankPage);
export default __webpack_public_path__ + "static/media/blankPage.0ad8d54ce00ed697322e2595e412d8e4.svg";
export { ForwardRef as ReactComponent };